import apiClient from './api';
import type { ApiResponse, LoginRequest, LoginResponse, User } from '@/types';
import { STORAGE_KEYS } from '@/constants';

export const authService = {
  /**
   * Login user
   */
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await apiClient.post<ApiResponse<LoginResponse>>(
      '/auth/admin/login',
      credentials
    );
    const { accessToken } = response.data.data;
    // Store access token
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
    return response.data.data;
  },

  /**
   * Logout user
   */
  async logout(): Promise<void> {
    await apiClient.post('/auth/admin/logout');
    // Only clear local storage if API call succeeds
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER_INFO);
    localStorage.removeItem(STORAGE_KEYS.MENU_TYPE);
  },

  /**
   * Get current user info
   */
  async getCurrentUser(): Promise<User> {
    const response = await apiClient.get<ApiResponse<User>>('/auth/admin/me');
    const user = response.data.data;
    // Save user info to localStorage
    localStorage.setItem(STORAGE_KEYS.USER_INFO, JSON.stringify(user));
    return user;
  },

  /**
   * Gửi OTP đến email admin
   * @param adminEmail Email của admin
   * @returns Promise trả về response từ server
   */
  async sendAdminOtp(adminEmail: string) {
    return apiClient.post('/auth/admin/send-otp', { adminEmail });
  },

  /**
   * Đổi mật khẩu qua OTP (quên mật khẩu)
   * @param params { adminEmail, adminPassword, otpCode }
   * @returns Promise trả về response từ server
   */
  async forgotPassword(params: { adminEmail: string; adminPassword: string; otpCode: string }) {
    return apiClient.post('/auth/admin/forgot-password', params);
  },

  /**
   * Refresh access token
   */
  async refreshToken(): Promise<string> {
    const response = await apiClient.post<ApiResponse<{ accessToken: string }>>(
      '/auth/refresh',
      {}
    );

    const newAccessToken = response.data.data.accessToken;
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, newAccessToken);

    return newAccessToken;
  },

  /**
   * Check if user is authenticated
   */
  isAuthenticated(): boolean {
    return !!localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  },

  /**
   * Get stored user info
   */
  getStoredUser(): User | null {
    const userStr = localStorage.getItem(STORAGE_KEYS.USER_INFO);
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch {
        return null;
      }
    }
    return null;
  },
};

